"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isListingSite = exports.isTestLead = exports.isValidUserSessionRecordingSponsor = exports.validateMessageLength = void 0;
var LISTING_SITES = {
    atc: true,
    kbb: true,
    fordcpocox: true
};
var validateMessageLength = function (message) {
    return message.length <= 500;
};
exports.validateMessageLength = validateMessageLength;
var approvedSponsors = ['atc', 'ddc', 'kbb'];
var isValidUserSessionRecordingSponsor = function (sponsor) {
    return sponsor && approvedSponsors.indexOf(sponsor.toLowerCase()) > -1;
};
exports.isValidUserSessionRecordingSponsor = isValidUserSessionRecordingSponsor;
var isTestLead = function (shopperInfo) {
    var phone = shopperInfo.phone, firstName = shopperInfo.firstName, lastName = shopperInfo.lastName, email = shopperInfo.email;
    if (firstName === 'Test') {
        return true;
    }
    if (lastName === 'Dealercom' || lastName === 'Test' || lastName === 'Accelerate' || lastName === 'Dealer com') {
        return true;
    }
    if (email === 'nan@email.com' || email === 'test@test.com') {
        return true;
    }
    if (phone === '888-888-8888' || phone === '503-736-2985') {
        return true;
    }
    return false;
};
exports.isTestLead = isTestLead;
var isListingSite = function (sponsor) {
    return sponsor && !!LISTING_SITES[sponsor.toLowerCase()];
};
exports.isListingSite = isListingSite;
